import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _SourceToPayFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M22 14.001C22.5523 14.001 23 14.4487 23 15.001C22.9997 19.423 19.4221 23.001 15 23.001C14.6397 23.001 14.3074 22.8067 14.1299 22.4932C13.9524 22.1797 13.9573 21.7952 14.1426 21.4863L15.1924 19.7363C15.4765 19.2628 16.0909 19.1086 16.5645 19.3926C17.0088 19.6592 17.1713 20.2168 16.9551 20.6758C19.3105 19.8663 20.9998 17.6337 21 15.001C21 14.4487 21.4477 14.001 22 14.001Z"
        fill={iconColor}
      />
      <Path
        d="M10 19.8467C10 21.4787 8.20914 22.8008 6 22.8008C3.79086 22.8008 2 21.4787 2 19.8467V18.501C2.22685 18.772 2.47719 19.0086 2.74609 19.2051C3.62152 19.8512 4.77371 20.2158 6 20.2158C7.22629 20.2158 8.37848 19.851 9.25391 19.2041C9.51896 19.0092 9.77379 18.7734 10 18.501V19.8467Z"
        fill={iconColor}
      />
      <Path
        d="M6 13.2012C8.20904 13.2012 9.99983 14.5224 10 16.1543C10 17.7863 8.20914 19.1084 6 19.1084C3.79086 19.1084 2 17.7863 2 16.1543C2.00017 14.5224 3.79096 13.2012 6 13.2012Z"
        fill={iconColor}
      />
      <Path
        d="M16.7695 6.03418C17.0421 6.22055 17.2051 6.53017 17.2051 6.86035V11.3418C16.8155 11.3084 16.4086 11.207 16.0527 11.0059L13.5322 9.60938C13.0566 9.34895 12.6841 8.92749 12.4336 8.5C12.1825 8.0714 12 7.54393 12 7.01074V4.33691C12 3.8672 12.1429 3.40403 12.3467 3.01074L16.7695 6.03418Z"
        fill={iconColor}
      />
      <Path
        d="M22.6299 2.96289C22.8473 3.36911 23 3.85028 23 4.33691V7.01074C23 7.54834 22.8127 8.07723 22.5615 8.50293C22.3103 8.92862 21.9392 9.34762 21.4717 9.60742L18.9453 11.0068L18.9443 11.0078C18.6967 11.1457 18.4248 11.2355 18.1514 11.29V6.81836C18.1514 6.50334 18.2996 6.2064 18.5518 6.01758L22.6299 2.96289Z"
        fill={iconColor}
      />
      <Path
        d="M9 1.00098C9.36027 1.00098 9.69261 1.19431 9.87012 1.50781C10.0476 1.82125 10.0427 2.20575 9.85742 2.51465L8.80762 4.26465C8.52351 4.73816 7.9091 4.89238 7.43555 4.6084C6.99124 4.34182 6.82868 3.78413 7.04492 3.3252C4.68938 4.13472 3 6.36806 3 9.00098C2.99974 9.55304 2.55212 10.001 2 10.001C1.44788 10.001 1.00026 9.55304 1 9.00098C1 4.57869 4.57772 1.00098 9 1.00098Z"
        fill={iconColor}
      />
      <Path
        d="M17.5039 0C17.9728 0 18.4963 0.0940489 18.9404 0.337891L18.9434 0.339844L21.4678 1.73828C21.6926 1.86138 21.8936 2.02168 22.0703 2.2002L18.2363 5.07031C17.8938 5.32659 17.4255 5.33609 17.0723 5.09473L12.8945 2.23926C13.0791 2.04526 13.2919 1.87214 13.5293 1.74023L16.0674 0.333984C16.5126 0.0943378 17.0342 3.41979e-05 17.5039 0Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const SourceToPayFilledIcon = assignWithoutSideEffects(_SourceToPayFilledIcon, {
  componentId: 'SourceToPayFilledIcon',
});

export default SourceToPayFilledIcon;
